module.exports = __webpack_public_path__ + "img/burger.77f40f8e.svg";